import { http } from './http';

export async function getOperations(params) {
    return http.get('wms/operations/', { params });
}

export async function createOperation(data) {
    return http.post('wms/operations/', data);
}

export async function updateOperation(id, data) {
    // По ТЗ «Рабочие задачи» блок 4: PATCH (частичное обновление) — PUT грозит потерей M2M.
    return http.patch(`wms/operations/${id}/`, data);
}

export async function getOperationById(id) {
    return http.get(`wms/operations/${id}/`);
}

export async function deleteOperation(id) {
    return http.delete(`wms/operations/${id}/`);
}
